var ReactTooltip = require("react-tooltip");

var Glyphicon = function(props) {
	var className = "glyphicon glyphicon-" + props.icon;
	if (props.className) {
		className += " " + props.className;
	}
	if (props.dataTip) {
		var spanProps = _.omit(props, "dataTip");

		return (
			<span>
				<span { ...spanProps }  className={ className } data-tip data-for={props.dataTip}/>
				<ReactTooltip id={props.dataTip}>
					<span> {props.dataTip}</span>
				</ReactTooltip>
			</span>
		);

	} else {
		return (
			<span { ...props } className={ className } />
		);		
	}
};

Glyphicon.propTypes = StrictPropTypes({
	// "glyphicon glyphicon-*" class will be added to this
	className: PropTypes.string,

	// Glyphion suffix
	icon: PropTypes.string.isRequired,

	// Passed on to span
	dataTip: PropTypes.string,
	style: PropTypes.object,
	onClick: PropTypes.func
});

module.exports = Glyphicon;



// WEBPACK FOOTER //
// ./modules/components/utility/icons/Glyphicon.js